<template>
  <div style="position: relative;padding-top: 3rem;">
    <div class="news-top-img">
      <img src="@/assets/img/special-fund/navigation-fund-detail.png" alt="" width="100%">
    </div>
    <div class="navigation-title" style="margin-top: 0;color: white;"><span @click="()=>{$router.push('/news')}">{{ $t('News') }} </span> <i class="el-icon-arrow-right"></i> {{ article.title }}</div>
    <div class="news-article">
      <h2 style="text-align: center;">{{ article.title }}</h2>
      <div class="meta">
        <span style="position: relative;top: 0rem;">
          <span class="date"> <i class="el-icon-time"></i> {{ article.createDate }}</span>
          <span class="views"><i class="el-icon-view"></i> {{ article.pageView }}</span>
        </span>
        <span>
          {{$t('Share')}}：
          <span style="position: relative;top: -0.1rem;">
            <!-- <img src="@/assets/img/weixin.png" alt="" style="width: 1.3rem;height: 1.3rem;margin-left: 0.5rem;cursor: pointer;"> -->
            <img src="@/assets/img/weibo.png" alt="" style="width: 1.3rem;height: 1.3rem;margin-left: 0rem;cursor: pointer;" @click="toWeibo">
          </span>
        </span>
      </div>

      <div class="content" v-if="isMobile=='pc'">
        <div v-html="processedHtml" class="details-content"></div>
      </div>
      
      <div class="content-mobile" v-if="isMobile=='mobile'">
        <div v-html="processedHtml" class="news-article-content"></div>
      </div>

      <el-divider></el-divider>
      <div class="news-article-bottom">
        <span @click="article.upPage?toNewsDetail(article.upPage?article.upPage.id:0):''" style="cursor: pointer;">
          <span style="color: #8A8A8A;">{{$t('PreviousArticle')}}：{{article.upPage?article.upPage.title:'没有了' }} </span>
        </span>
        <span @click="article.downPage?toNewsDetail(article.downPage?article.downPage.id:0):''" style="cursor: pointer;">
          <span style="color: #8A8A8A;cursor: pointer;">{{$t('NextArticle')}}：{{article.downPage ?article.downPage.title:'没有了'}}</span>
        </span>
      </div>
    </div>
  </div>

</template>

<script>
import { getArticleById } from '@/api/index';
export default {
  props: {
    // article: {
    //   type: Object,
    //   required: true
    // }
  },
  computed:{
    processedHtml() {
      return this.article.content.replace(/<img(.*?)style=".*?"(.*?)>/g, '<img$1$2>');
    },
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      article: {}
    }
  },
  mounted() {
  	const meta = document.createElement('meta');
  	meta.setAttribute('name','referrer');
  	meta.setAttribute('content','never');
  	document.head.appendChild(meta);
  	  
    this.id = this.$route.query.id
	this.fundId = this.$route.query.fundId
    this.getArticleByIds(this.id)
  },
  methods: {
    toNewsDetail(id) {
      this.$router.push({
        path: '/specialFundNewsDetails',
        query: {
          id: id,
		  fundId:this.fundId
        }
      })
    },
    toWeibo() {
      // console.log("this.$utils",this.$utils);
      //this.shareToSinaWeiBo(this.article.title,this.article.imgUrl,this.article.content)
	  if(this.article.url == null || this.article.url == ''){
	  		  this.shareToSinaWeiBo(this.article.title, window.location.href, this.article.imgUrl)
	  }else{
	  		  this.shareToSinaWeiBo(this.article.title, this.article.url, this.article.imgUrl)
	  }
    },
	async getArticleByIds(id) {
	  let form = new FormData();
	  form.append("id", id);
	  form.append("moduleTypeId", this.fundId);
	  let res = await getArticleById(form)
	  if (res.data && res.data != null) {
	    this.article = res.data
	  }
	}
    
  }
}
</script>

<style lang="less" scoped>
.news-top-img {
  position: absolute;
  top: 0;
  z-index: -1;
}
.news-article {
  box-sizing: border-box;
  background-color: white;
  padding: 2rem;
  padding-top: 1rem;
  width: 80%;
  margin: 2rem auto;
  border-radius: 0.3rem;
  position: relative;
  .news-article-bottom {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.meta {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  color: #888;
  .views {
    margin-left: 2rem;
  }
}

.content {
  font-size: 1rem;
  line-height: 2rem;
}

.news-image {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}
.details-content {
  display: inline-block;
  overflow: auto;
  width: 100%;
  img {
    width: 100% !important;
  }
}
.content-mobile{
  .news-article-content{
    display: inline-block;
    width: 100%;
    img{
      width: 100% !important;
      height: 20rem !important;
    }
  }
}
</style>